import React from 'react'
import { Title } from '../components'
import { ForgottenPasswordForm } from '../forms'

const ForgottenPasswordPage = () => (
  <div style={{ marginTop: '10rem' }}>
    <Title message="Forgotten password" />
    <h1>Reset password:</h1>
    <ForgottenPasswordForm />
  </div>
)

export default ForgottenPasswordPage



// WEBPACK FOOTER //
// ./src/browser/pages/ForgottenPasswordPage.js